import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Page, Button, Subheading, PageActions } from '@shopify/polaris';
import { ExportMinor, ClipboardMinor, PageDownMajorMonotone } from '@shopify/polaris-icons';
import DispatchControlOrders from './components/DispatchOrders';
import CopyToClipboardProvider from '@shared/CopyToClipboardProvider';
import axios from 'utils/axios-rails';

import reduce from 'lodash/reduce';

const propTypes = {
  dispatch_control: PropTypes.object.isRequired,
  pdfURL: PropTypes.string.isRequired,
  cancelDeliveryBaseURL: PropTypes.string, // For Uber/Fruno/Mail Americas: allow cancelling orders when not yet delivered - baseURL with PLACEHOLDER_ID
  pdfURLFruno: PropTypes.string,
  timelineBaseURL: PropTypes.string,
}

const defaultProps = {

}

const DispatchControlShow = (props) => {
  const [loading, setLoading] = useState(false);
  const { dispatch_control } = props;

  const title = `${I18n.t("activerecord.models.dispatch_control.one")} ${dispatch_control.name}`;

  // Setup ids to copy to clipboard
  let ids = dispatch_control.dispatch_orders[0].shopify_id; // when only one.
  if (dispatch_control.dispatch_orders.length > 1) {
    ids = reduce(dispatch_control.dispatch_orders, (str, order) => {
      if (typeof (str) == "string") {
        return `${str},${order.shopify_id}`;
      }
      else {
        // str == first element on first iteration
        return `${str.shopify_id},${order.shopify_id}`;
      }
    });
  }

  // TODO Change to UI alerts instead of JS alerts
  const handleCancelDelivery = async (dispatchOrderId) => {
    setLoading(true);
    if (confirm(I18n.t("messages.irreversible_action"))) {
      try {
        const response = await axios.post(props.cancelDeliveryBaseURL.replace("PLACEHOLDER_ID", dispatchOrderId));
        if (response.data.success) {
          alert("Cancelada correctamente");
          location.reload(); // Not efficient but was the faster way at the time
        } else {
          alert(`Ocurrio un error al cancelar: ${response.data.message}`);
        }
      } catch (error) {
        console.log("Error", error);
        alert("Ocurrio un error en el sistema");
      }
    }
    setLoading(false);
  };

  // Replace PLACEHOLDER_ID with dispatch_control.id if pdfURLFruno is present
  const pdfUrlFruno = props.pdfURLFruno ? props.pdfURLFruno.replace("PLACEHOLDER_ID", dispatch_control.id) : null;

  return (
    <AppProvider>
      <CopyToClipboardProvider
        value={ids}
      >
        {({ copyToClipboard }) => {
          let secondaryActions = [
            { content: "Copiar IDs", icon: ClipboardMinor, onAction: copyToClipboard },
            { content: "Exportar PDF", icon: ExportMinor, url: `${props.pdfURL}.pdf`, external: true },
          ]

          if(pdfUrlFruno){
            secondaryActions.push({ content: "Exportar Guías", icon: PageDownMajorMonotone, url: pdfUrlFruno, external: true });
          }

          return (
            <Page
              fullWidth
              title={ title }
              titleMetadata={
                <span>{dispatch_control.created_at_text}</span>
              }
              subtitle={
                <strong>
                  {I18n.t("activerecord.models.team", { count: 1 })}: {dispatch_control.team.name}
                  { !!dispatch_control.uber_vehicle &&
                    <>
                      <br/>
                      <span>Uber: {I18n.t(`enum.uber_vehicle.${dispatch_control.uber_vehicle}`)} </span>
                    </>
                  }

                </strong>
              }
              secondaryActions={secondaryActions}
              breadcrumbs={[{ content: I18n.t("actions.back"), url: '/admin/dispatch_controls' }]}>
              <div className="mt20 mb20">
                <DispatchControlOrders
                  isShow
                  onCancelDelivery={props.cancelDeliveryBaseURL ? handleCancelDelivery : null}
                  orders={dispatch_control.dispatch_orders}
                  uber={dispatch_control.team.uber}
                  loading={loading}
                  pdfURLFruno={pdfUrlFruno}
                  timelineBaseURL={props.timelineBaseURL}
                  providerName={dispatch_control.provider_name}
                />
              </div>
            </Page>
          )
        }}
      </CopyToClipboardProvider>
    </AppProvider>
  )
}

DispatchControlShow.propTypes = propTypes;
DispatchControlShow.defaultProps = defaultProps;

export default DispatchControlShow;
